export class TimelineMedia {
  constructor(
    readonly id: string,
    readonly name: string,
    readonly url: string,
    readonly contentType: string,
  ) {}
}
